import React, { memo } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { CommonProperties, Color } from '../../styles';
import BaseText from '../BaseText';
import Icon from '../Icon';
import ListControl from './ListControl';

const SegmentItem = ({ label, selected, icon, onPress }) => {
  return (
    <TouchableOpacity
      style={[styles.item, selected ? styles.itemSelected : null]}
      onPress={onPress}
    >
      <Icon name={icon} color={selected ? Color.active : Color.primary} size={23} />
      <BaseText style={{ ...CommonProperties.h4, color: selected ? Color.active : Color.primary }}>
        {label}
      </BaseText>
    </TouchableOpacity>
  );
};

const CircleSegmentedControl = memo(({ items, selected, onChange, style, ...rest }) => {
  return (
    <ListControl
      style={[styles.listControl, style]}
      items={items}
      renderItem={(item) => (
        <SegmentItem
          onPress={() => onChange(item.value)}
          selected={item.value === selected}
          label={item.label}
          icon={item.icon}
        />
      )}
      {...rest}
    />
  );
});

const styles = StyleSheet.create({
  listControl: {
    borderRadius: 50,
    justifyContent: 'space-around',
    overflow: 'visible',
    ...CommonProperties.py2,
    ...CommonProperties.mx5,
    ...CommonProperties.mb3,
    ...CommonProperties.shadow,
  },
  item: {
    ...CommonProperties.justifyCenter,
    alignItems: 'center',
    ...CommonProperties.px2,
  },
  itemSelected: {
    borderBottomColor: Color.active,
    borderBottomWidth: 2,
  },
});

export default CircleSegmentedControl;
